module.exports = __webpack_public_path__ + "static/media/blueLogo.8874092f.png";